module.exports = __webpack_public_path__ + "static/media/reimagined-solution.9836fee3.svg";